import React,{useContext} from "react";
import qrcode from '../../assets/images/qrcode.png';
import numberbeautify from "../../utils/numberbeautify";
import './loanbackprint.css';
import Logo from '../../assets/images/logo.png'
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";
import moment from "moment/moment";
import { GlobalContext } from "../../context/provider";

export const Company_ledger_table_print = React.forwardRef((props, ref) => {
    const { initState } = useContext(GlobalContext);
    return (
         <div ref={ref}>
            <div dir="rtl" className="">
              <div className="py-2 bottom-1">
                <div className="px-14 py-7 relative flex justify-between items-center">
                  <div>
                    <p className="whitespace-nowrap text-slate-400 text-right">بەروار</p>
                    <p className="whitespace-nowrap font-medium text-right text-[#D9A919]">{moment().format("YYYY-MM-DD hh:mm A")}</p>
                  </div>
                  <div>
                    <img src={Logo} className="h-24 absolute left-1/2 transform -translate-x-1/4 -top-1" />
                  </div>
                  {/* <div className="flex">
                    <div className="mx-3">
                        <p className="whitespace-nowrap text-slate-400 text-right">ژمارەی پسوڵە #</p>
                        <p className="whitespace-nowrap font-medium text-right text-[#D9A919]">{props?.loan_in_id}</p>
                    </div>
                    <div className="mx-3">
                        <p className="whitespace-nowrap text-slate-400 text-right">نرخی دۆلار</p>
                        <p className="whitespace-nowrap font-medium text-right text-[#D9A919]">{numberbeautify(props?.dollar_price)}</p>
                    </div>
                  </div> */}
                </div>
                <div className="bg-slate-100 px-14 py-4 text-sm">
                  <table className="w-full border-collapse border-spacing-0">
                    <tbody>
                      <tr>
                        <td className="w-1/2 align-top">
                          <div className="text-sm text-neutral-600">
                            <div className="flex">
                              <p className="font-medium text-lg">کۆمپانیای: </p>
                              <p className="font-medium text-lg mx-1">{initState?.ledger_company_name}</p>
                            </div>
                            <div className="flex">
                              <p className="text-lg">ناونیشان: </p>
                              <p className="text-lg mx-1">{initState?.ledger_company_address}</p>
                            </div>
                            <div className="flex">
                              <p className="text-lg">ژمارەی تەلەفۆن: </p>
                              <p className="text-lg mx-1">{initState?.ledger_company_phone}</p>
                            </div>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                          </div>
                        </td>
                        <td className="w-1/2 align-top text-right">
                          <div className="text-sm text-neutral-600">
                            <p className="font-medium text-2xl text-[#D9A919]">کۆمپانیای خەندەی ماڵ</p>
                            <p className="text-lg">بۆ بازرگانی گشتی سنوردار / پێداویستی ناوماڵ</p>
                            <p className="text-lg">سلێمانی - ژاڵەی سەروو - کۆگاکانی ژووری بازرگانی</p>
                            <p className="text-lg">ژمارەی گەنجینە: ۲۷٥</p>
                            <p className="text-lg" dir="ltr">0770 159 1344 - 0770 152 8160</p>
                            <p></p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </div>      
            <div className="text-center text-2xl">
              کەشف حسابی کۆمپانیا
            </div>
            <div className="px-4 py-3 text-sm text-neutral-700">
                <table className="w-full border-collapse border-spacing-0">
                <thead>
                    <tr className="bg-black h-8 px-2 text-white">
                    <td className="pr-1 border-x-[1.5px] font-medium text-main">جۆری چالاکی</td>
                    <td className="pr-1 border-x-[1.5px] font-medium text-main">بەروار</td>
                    <td className="border-x-[1.5px] text-center font-medium text-main">ژمارە</td>
                    <td className="border-x-[1.5px] text-center font-medium text-main">بڕ</td>
                    <td className="border-x-[1.5px] text-center font-medium text-main">بڕی قەرز</td>
                    </tr>
                </thead>
                <tbody>
                    {(() => {
                        let remained = 0;
                        return props?.ledger?.map((lis, index) => {
                            var amount = Number(lis.total_amount) || 0;

                            if (lis.action_type === "init_loan") {
                                remained += amount;
                            } else if (lis.action_type === "loan_out") {
                                remained -= amount;
                            } else {
                            // assume sells that were loans increase the remained loan
                            if (lis.company_invoice_type === "loan") {
                                remained += amount;
                            }
                            }
    
                            return (
                            <tr key={index}>
                                <td className="border-l-[1.5px] py-3 pr-2">
                                    {lis.action_type === "init_loan"
                                    ? "قەرزی بنچینەیی"
                                    : lis.action_type === "loan_out"
                                    ? "قەرزی دراوە"
                                    : "کڕین" + (lis.company_invoice_type === "loan" ? " (قەرز)" : " (کاش)")}
                                </td>
                                <td className="border-l-[1.5px] py-3 pr-2">
                                    {lis.action_type === "init_loan"
                                    ? "-"
                                    : moment(lis.ledger_date).format("YYYY-MM-DD hh:mm A")}
                                </td>
                                <td className="border-l-[1.5px] py-3 pr-2">
                                    {lis.action_type === "init_loan" ? "-" : lis.ledger_id}
                                </td>
                                <td className="border-l-[1.5px] py-3 pr-2">
                                    {numberbeautify(money_rounding(lis.total_amount))} $
                                </td>
                                <td className="border-l-[1.5px] py-3 pr-2">
                                    {numberbeautify(money_rounding(remained))} $
                                </td>
                            </tr>
                            );
                        });
                    })()}
                </tbody>
                </table>
            </div>
          </div>
         </div>
      );
})